import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface LockIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const LockIcon = ({ className, ...props }: LockIconProps) => (
  <svg
    className={cn("text-[#6C8FD4]", className)}
    fill="none"
    height="17"
    viewBox="0 0 14 17"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.25 7.41667V4.08333C3.25 3.19928 3.60119 2.35143 4.22631 1.72631C4.85143 1.10119 5.69928 0.75 6.58333 0.75C7.46739 0.75 8.31524 1.10119 8.94036 1.72631C9.56548 2.35143 9.91667 3.19928 9.91667 4.08333V7.41667M0.75 9.08333C0.75 8.64131 0.925595 8.21738 1.23816 7.90482C1.55072 7.59226 1.97464 7.41667 2.41667 7.41667H10.75C11.192 7.41667 11.616 7.59226 11.9285 7.90482C12.2411 8.21738 12.4167 8.64131 12.4167 9.08333V14.0833C12.4167 14.5254 12.2411 14.9493 11.9285 15.2618C11.616 15.5744 11.192 15.75 10.75 15.75H2.41667C1.97464 15.75 1.55072 15.5744 1.23816 15.2618C0.925595 14.9493 0.75 14.5254 0.75 14.0833V9.08333ZM5.75 11.5833C5.75 11.8043 5.8378 12.0163 5.99408 12.1726C6.15036 12.3289 6.36232 12.4167 6.58333 12.4167C6.80435 12.4167 7.01631 12.3289 7.17259 12.1726C7.32887 12.0163 7.41667 11.8043 7.41667 11.5833C7.41667 11.3623 7.32887 11.1504 7.17259 10.9941C7.01631 10.8378 6.80435 10.75 6.58333 10.75C6.36232 10.75 6.15036 10.8378 5.99408 10.9941C5.8378 11.1504 5.75 11.3623 5.75 11.5833Z"
      stroke="#3F3A3B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default LockIcon;
